import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import classNames from "classnames";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import Favorite from "@material-ui/icons/Favorite";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import { TiArrowForward } from "react-icons/ti";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { localApi, credentials, adminId, convertToNextTenth } from "utils/headApi";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Spinner from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";
import CornerRibbon from "react-corner-ribbon";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";

import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import logo from "assets/img/examples/apple-insha-bangles-icon.png";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

const useStyles = makeStyles(productStyle);
const useStyle = makeStyles(aboutUsStyle);
const useStylPop = makeStyles(popOver);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function InshaShopify() {
  const [prodList, setProdList] = React.useState([]);
  const [page, setpage] = React.useState(0);
  const [loginModal, setLoginModal] = React.useState(false);

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [editedDescriptions, setEditedDescriptions] = React.useState({});

  const classes = useStyles();
  const classe = useStyle();
  const classPop = useStylPop();

  const activeSession = sessionStorage.getItem("sessionData");

  const PAGE_SIZE = 4;

  async function getProdSEO() {
    const results = await fetch(
      localApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }
    );
    const res = await results.json();

    setStateList(res.map((f) => f.state));

    axios.get(localApi + `/admin/allList`, {
      headers: { Authorization: `Basic ${credentials}` },
    }).then((res) => {
      setCompanyList(res.data.AdminList.map((f) => f.company));
    });

    axios.get(localApi + `/category/allList`, {
      headers: { Authorization: `Basic ${credentials}` },
    }).then((res) => {
      const items = res.data.map((f) => f.title);
      const uniqueItems = items.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );
      setCategoryList(uniqueItems);
    });

    axios.get(localApi + `/parent/allList`, {
      headers: { Authorization: `Basic ${credentials}` },
    }).then((res) => {
      const itemss = res.data.map((f) => f.title);
      const uniqueItemss = itemss.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );
      setParentList(uniqueItemss);
    });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${localApi}/product/list/byAdminId/${adminId}`,
        {
          method: "GET",
          headers: { Authorization: `Basic ${credentials}` },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setProdList(data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchData();
    setTimeout(hideAlertPop, 2000);
    setLoginModal(true);
  }, []);

  useEffect(() => {
    setpage(1);
  }, [searchTerm]);


  const hideAlertPop = () => {
    setLoginModal(false);
  };

  const handleDescriptionChange = (id, value) => {
    setEditedDescriptions((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const updateProductDescription = async (prdId, prodDescription) => {
    try {
      const response = await fetch(
        localApi + `/product/updateContent/byProductId/${prdId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({ prodDescription }),
        }
      );

      const data = await response.json();
      // console.log("Updated:", data);

      setProdList((prev) =>
        prev.map((p) =>
          p.id === prdId ? { ...p, prodDescription } : p
        )
      );

      setEditedDescriptions((prev) => {
        const copy = { ...prev };
        delete copy[prdId];
        return copy;
      });
    } catch (err) {
      console.error("Update failed", err);
    }
  };

  const normalizeText = (text = "") =>
    text
      .toLowerCase()
      .replace(/\n/g, " ")
      .replace(/(\d+)\s*mm/g, "$1mm")   // 4 mm → 4mm
      .replace(/mm\s*(\d+)/g, "$1mm")   // mm 4 → 4mm
      .replace(/-/g, " ")               // 1mm-1 → 1mm 1
      .replace(/[^\w\s.]/g, " ")        // remove special chars
      .replace(/\s+/g, " ")
      .trim();


  const filteredProdList = prodList.filter((prod) => {
    if (!searchTerm.trim()) return true;

    // 🔹 normalize search
    const searchWords = normalizeText(searchTerm).split(" ");

    // 🔹 safe fields
    const parentTitle =
      typeof prod.parent === "string"
        ? prod.parent
        : prod.parent?.title || "";

    const categoryTitle =
      typeof prod.category === "string"
        ? prod.category
        : prod.category?.title || "";

    const avgGram =
      prod.readyGram && prod.sets?.pcs
        ? (prod.readyGram * prod.sets.pcs).toString()
        : "";

    const childTitles = Array.isArray(prod.productchild)
      ? prod.productchild.map((c) => c.title).join(" ")
      : "";

    // 🔹 build searchable text
    const searchableText = normalizeText(
      [
        prod.id,
        prod.prodDescription,
        prod.itemCodeNumber,
        categoryTitle,
        parentTitle,
        avgGram,
        prod.sets?.setDesc,
        prod.box?.boxDesc,
        prod.packingMaterial?.type,
        prod.box?.brandName,
        prod.ctnDescription,
        childTitles,
      ]
        .filter(Boolean)
        .join(" ")
    );

    // 🔍 DEBUG (keep while testing)
    // console.log("SEARCH WORDS:", searchWords);
    // console.log("SEARCH TEXT:", searchableText);

    // ✅ EVERY word must exist (order independent)
    return searchWords.every((word) => searchableText.includes(word));
  });

  const paginatedProducts = filteredProdList.slice(
    0,
    page * PAGE_SIZE
  );


  return (
    <div className={classes.productPage}>
      <Helmet>
        <title>Product List</title>
        <meta
          name="description"
          content="We make bangles with good quality raw material at factory prices..."
        />
        <meta
          name="keywords"
          content={`${categoryList},${parentList},${stateList},${companyList}`}
        />
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="transparent"
        changeColorOnScroll={{ height: 100, color: "dark" }}
      />
      <Parallax filter="dark" className={classes.pageHeader}>
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem md={8} sm={8} className={classNames(classe.mlAuto, classe.mrAuto, classe.textCenter)}>
              <h1 className={classe.title}>Shopify List</h1>
              <h4 style={{ color: "white" }}>
                Insha{"'"}s products are light-weight, elegant and sophisticated
              </h4>
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                <input
                  type="text"
                  placeholder="Search by gram, size, set, box, child title..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: "100%",
                    maxWidth: "420px",
                    padding: "12px 18px",
                    borderRadius: "25px",
                    border: "1px solid #ddd",
                    outline: "none",
                    fontSize: "15px",
                  }}
                />
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.section, classes.sectionGray)}>
        <div className={classes.container}>
          <Dialog
            style={{ marginTop: "10%" }}
            classes={{ root: classPop.modalRoot, paper: classPop.modal + " " + classPop.modalLogin }}
            open={loginModal}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="login-modal-slide-title"
            aria-describedby="login-modal-slide-description"
          >
            <DialogTitle id="login-modal-slide-title" disableTypography className={classPop.modalHeader}>
              <h5>Loading...</h5>
              <DialogContent id="login-modal-slide-description" className={classPop.modalBody}>
                <GridContainer justify="center">
                  <Spinner style={{ color: "black" }} />
                </GridContainer>
                <br />
              </DialogContent>
            </DialogTitle>
          </Dialog>
          <div className={classes.relatedProducts}>
            <h3 className={classNames(classes.title, classes.textCenter)}>
              You may also be interested in:
            </h3>
            <InfiniteScroll
              dataLength={paginatedProducts.length}
              next={() => setpage((prev) => prev + 1)}
              hasMore={paginatedProducts.length < filteredProdList.length}
            >
              <div className={classes.container}>
                <GridContainer>
                  {paginatedProducts.map((prod) => {
                    let resultChild = "";   // initialize empty string

                    (prod.productchild || []).forEach((item) => {
                      let line = item.title.trim();

                      if (line.includes("Plating")) {
                        // Remove [ ] brackets
                        line = line.replace(/\[/g, "").replace(/\]/g, "").trim();

                        // Extract only text AFTER "Plating"
                        const afterPlating = line
                          .substring(line.indexOf("Plating") + "Plating".length)
                          .trim();

                        // Clean again
                        const cleanText = afterPlating
                          .replace(/\[/g, "")
                          .replace(/\]/g, "")
                          .trim();

                        // Add to final string
                        resultChild += cleanText + " ";
                      }
                    });
                    return (
                      <GridItem sm={6} md={3} key={prod.id}>
                        <Card product>
                          <CardHeader image>
                            <div style={{ position: "relative" }}>
                              <a href={`/indian-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}>
                                <img src={prod.productimage[0].cpanelPath} alt="..." style={{ width: "100%" }} />
                              </a>
                              <Button
                                justIcon
                                simple
                                style={{ position: "absolute", top: "10px", right: "10px", background: "rgba(0,0,0,0.6)", borderRadius: "50%", zIndex: 10 }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  window.open(prod.productimage[0].cpanelPath, "_blank");
                                }}
                              >
                                <GetAppIcon style={{ color: "#fff" }} />
                              </Button>
                              <p style={{ position: "absolute", top: "65%", left: "50%", width: "65px", height: "65px", transform: "translate(-50%, -50%)" }}>
                                <img src={logo} alt="..." />
                              </p>
                            </div>
                          </CardHeader>

                          <CardBody>
                            <h6 className={classNames(classes.cardCategory, classes.textRose)}>
                              {prod.category.title + " " + prod.parent.title} <br /> {resultChild.trim()}-{prod.id}
                            </h6>

                            {/* Editable Description */}
                            <h4 className={classes.cardTitle}>
                              {prod.prodDescription ? (
                                editedDescriptions[prod.id] !== undefined ? (
                                  <input
                                    type="text"
                                    value={editedDescriptions[prod.id]}
                                    onChange={(e) => handleDescriptionChange(prod.id, e.target.value)}
                                    onBlur={() => updateProductDescription(prod.id, editedDescriptions[prod.id])}
                                    style={{
                                      width: "100%",
                                      padding: "6px 10px",
                                      fontSize: "14px",
                                      borderRadius: "6px",
                                      border: "1px solid #ccc",
                                    }}
                                    autoFocus
                                  />
                                ) : (
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <span style={{ flex: 1 }}>{prod.prodDescription}</span>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDescriptionChange(prod.id, prod.prodDescription)}
                                      style={{ marginLeft: "8px" }}
                                    >
                                      <EditIcon fontSize="small" style={{ color: "#e91e63" }} />
                                    </IconButton>
                                  </div>
                                )
                              ) : (
                                <input
                                  type="text"
                                  placeholder="Enter product description"
                                  value={editedDescriptions[prod.id] || ""}
                                  onChange={(e) => handleDescriptionChange(prod.id, e.target.value)}
                                  onBlur={() => updateProductDescription(prod.id, editedDescriptions[prod.id])}
                                  style={{
                                    width: "100%",
                                    padding: "6px 10px",
                                    fontSize: "14px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                  }}
                                />
                              )}
                            </h4>

                            <div className={classes.cardDescription}>
                              {(prod.readyGram * prod.sets.pcs).toFixed(4)} Avg Gram Of {prod.sets.setDesc} {"and "} {prod.box.boxDesc}, {"(" + prod.packingMaterial.type + ")"}, {prod.box.brandName}, {prod.ctnDescription}.
                            </div>
                          </CardBody>

                          <CardFooter className={classes.justifyContentBetween}>
                            <div className={classes.price}>
                              {prod.gstCash ? (
                                <h5><span style={{ color: "red" }}>Price ₹ {convertToNextTenth(prod.taxInclude)} Inc.</span></h5>
                              ) : (
                                <h5><span style={{ color: "black" }}>Price ₹ {convertToNextTenth(prod.cashPrice)}</span></h5>
                              )}
                            </div>
                            <div className={classes.stats}>
                              <Tooltip id="tooltip-top" title="Save to Wishlist" placement="top" classes={{ tooltip: classes.tooltip }}>
                                <Button justIcon color="rose" simple><Favorite /></Button>
                              </Tooltip>
                            </div>
                          </CardFooter>

                          <div style={{ textAlign: "center", marginBottom: "7px" }}>
                            <Button color="rose" href={`/indian-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}>Buy Now</Button>
                          </div>
                        </Card>
                      </GridItem>
                    )
                  })}
                </GridContainer>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
